
import React, { useContext } from "react";
import { Backdrop, Box, Button, Card, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { AirlineStops, Hail, HighlightOff } from "@mui/icons-material";
import { PersonAdd } from "@material-ui/icons";
import { BrandContext } from "../../../contexts/BrandContext";
import TaxiBookingContextProvider, { TaxiBookingContext } from "./BookTaxiContext";
import LocationSetter from "./LocationSetter";
import BookTaxiHeader from "./BookTaxiHeader";
import PickupTimeSetter from "./PickupTimeSetter";
import PassengerSetter from "./PassengerSetter";
import { cLog } from "../CustomLogger";
import FpSelector from "./FpSelector";
import DetailDialogue from "../TaxiBookingCommon/DetailDialogue";
import ExtraDetails from "./ExtraDetails";



export default function BookTaxiDialogue(props){
    
    const brandContext = useContext(BrandContext);
    
    const {
        showDialogue,
        setShowDialogue,       
    } = props;

    
    const {
        textContent:{
            addViaButton='',
            widget_cancelButton:cancelButtonText = '',
            addPassengerButton='',
            confirmButton='',
            bookATaxiAdminTitle='',
        }
    } = brandContext;


    
    const BookingForm = ()=> {
        
        const taxiBookingContext = useContext(TaxiBookingContext); 
        
        const {
            bookingData:{
                vias=[],
                passengers=[],
                
            },
            processingBooking,
            isReadyToSelectFp,
            confirmBooking,
            fpsAvailable,
            bookingComplete,
            successTaxiId,
        } = taxiBookingContext;


        const addItemSetSlide = (bookingDataKey,slideHook)=>{
            taxiBookingContext.setState((prevState) => {
                const { bookingData } = prevState;
                const updatedArr = [...bookingData[bookingDataKey], {
                    data:{},
                    valid:false
                }];
                const slideIndex = updatedArr.length - 1;  
                const updatedBookingData = {
                    ...bookingData, 
                    [bookingDataKey]: updatedArr,
                };
                return { 
                    bookingData: updatedBookingData,
                    focusKey:slideHook,
                    focusIndex:slideIndex
                };
            });
        }

        const isReadyFp = isReadyToSelectFp();

        if(successTaxiId > 0){
            return (
                <DetailDialogue taxiId={successTaxiId} setShowDialogue={setShowDialogue} showDialogue={showDialogue} profile="school"/>
            );
        }

        return(
            <Dialog
                fullWidth
                open={showDialogue}
                onClose={()=>{setShowDialogue(false)}}
                className="darkDialogue"
            >
                <DialogTitle>
                    {bookATaxiAdminTitle}
                </DialogTitle>
                <DialogContent>
                    <Box>
                        <Box sx={{marginTop:2,marginBottom:2}}>
                            <BookTaxiHeader/>
                        </Box>
                        <PickupTimeSetter bookingHook="pickupTime"/>
                        <LocationSetter titleLabel="taxiFromLabel" bookingHook="from"/>
                        {vias.map((via,index)=>(
                            <LocationSetter key={index} slideIndex={index} titleLabel="taxiViaLabel" bookingHook="via"/>
                        ))}
                        <Box className="dialogueSectionButonContainer">
                            <Button 
                                startIcon={<AirlineStops/>}
                                variant="contained"
                                onClick={()=>{
                                addItemSetSlide('vias','via');
                            }}>
                                {addViaButton}
                            </Button>
                        </Box>
                        <LocationSetter titleLabel="taxiToLabel" bookingHook="to"/>
                        {passengers.map((passenger,index)=>(
                            <PassengerSetter key={index} slideIndex={index} bookingHook="passengers"/>
                        ))}
                        <Box className="dialogueSectionButonContainer">
                            <Button 
                                startIcon={<PersonAdd/>}
                                variant="contained"
                                onClick={()=>{
                                    addItemSetSlide('passengers','passengers');
                                }}>
                                {addPassengerButton}
                            </Button>
                        </Box>
                        {isReadyFp &&
                            <FpSelector bookingHook="provider"/>                      
                        }
                        <ExtraDetails bookingHook="extraDetails"/>
                    </Box>
                    
                </DialogContent>
                <DialogActions>
                    <Button 
                        startIcon={<HighlightOff/>}
                        variant="outlined"
                        onClick={()=>{setShowDialogue(false)}}>
                        {cancelButtonText}
                    </Button>
                    {(isReadyFp  && fpsAvailable.length > 0) && 
                        <Button 
                            startIcon={<Hail/>}
                            variant="contained"
                            onClick={()=>{confirmBooking()}}>
                            {confirmButton}
                        </Button>
                    }
                </DialogActions>
                {processingBooking &&
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open
                        >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                }
            </Dialog>
        );
    }



    return (
        <TaxiBookingContextProvider>
            <BookingForm/>
        </TaxiBookingContextProvider>
    );

}




